module.exports = __webpack_public_path__ + "static/media/cartaknina.c841da74.png";